
















































import { dayjs, DW_FORMAT_JA_SHORT_WITHOUT_Y } from '../../../src_server/common/momentExtends';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { MessageDialog } from '../../utils/MessageDialog';
import TransferButton from '../../components/button/TransferButton.vue';

import { Vue, Component, Prop } from 'vue-property-decorator';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';
import ReportIcon from '../../components/icon/ReportIcon.vue';
import { LessonServiceFront } from '../../biz/LessonServiceFront';
import { Session } from '../../utils/Session';
import { routeHelper } from '../../utils/routeHelper';
import { getTeacherSuffixInSession } from '../../utils/building_trans';

@Component({
  components: { ReportIcon, TransferButton },
  filters: {
    dateFormat(value: string): string {
      if (!value) return '';
      return dayjs(value).format(DW_FORMAT_JA_SHORT_WITHOUT_Y);
    },
  },
})
export default class LessonStateCard extends Vue {
  @Prop()
  row!: LessonDTO;

  get isTransfered() {
    return this.row.lessons.reservation_state === LessonStates.TRANSFAR;
  }
  get isCommit() {
    return this.row.lessons.reservation_state === LessonStates.COMMIT;
  }
  get isPast() {
    return dayjs(this.row.lessons.start_dt).diff(dayjs()) < 0;
  }
  get isReportSent() {
    return this.row.lessons.reservation_state === LessonStates.ALREADY;
  }

  get isReservation() {
    return this.row.lessons.reservation_state === LessonStates.RESERVATION;
  }

  get teacherSuffix() {
    return getTeacherSuffixInSession();
  }

  async change() {
    this.$emit('transfer', this.row);
  }

  gotoDailyReport() {
    if (!this.row.lessons?.class_id) {
      MessageDialog.systemError('レッスンID', '日報への遷移時', this.row.lessons?.class_id).then();
      return;
    }
    routeHelper(this, 'StudentDailyReportPage', { class_id: this.row.lessons?.class_id.toString() });
  }

  clickTransfer() {
    routeHelper(this, 'StudentTransferRequestPage', { building: Session.getSessionBuildingId() });
  }

  async cancel(class_id: number) {
    const biz = new LessonServiceFront();
    await biz.cancel(class_id, (class_id) => {
      this.$emit('delete-lesson', class_id);
    });
  }
}
